import React from 'react'
import styled from 'styled-components'
import ImageBlock from '../components/LoginScreen/ImageBlock'
import LoginForm from '../components/LoginScreen/LoginForm'

const Authentication = () => {
  return (
    <Wrapper>
      <ImageBlock />
      <LoginForm />
    </Wrapper>
  )
}

export default Authentication

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
